module.exports = __webpack_public_path__ + "static/media/icon_car_front_side.43109bf1.svg";